var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32574)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#F19F13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8081 7.84692H15.5475L15.75 6.72192H13.1006C12.5783 6.73817 12.072 6.90628 11.6438 7.20567C11.4863 6.64317 9.95625 6.72192 9.95625 6.72192L10.1587 5.59692H9.5625L9.36 6.72192H8.73562L8.91 5.59692H8.26312L8.02688 6.72192H7.3575L7.01438 8.47692L6.55875 6.75567H5.0625L2.25 10.89H4.5675L4.80375 9.79317H4.33125L5.68125 7.8188L6.1875 9.80442H5.68125L5.46187 10.89H7.18313L7.0425 11.6438H7.7175L7.875 10.89H8.4375L8.29688 11.6438H9L9.14062 10.89H10.0181C10.4216 10.8443 10.7951 10.6546 11.07 10.3557C11.3977 10.6874 11.8414 10.8789 12.3075 10.89H14.9569L15.1312 9.79317H12.7519C11.115 9.76505 11.8125 7.83567 12.8081 7.84692ZM9.8325 9.76505H8.0775L8.21812 9.23067H9.90563C10.3331 9.2588 10.1925 9.76505 9.8325 9.76505ZM10.0969 8.32505H8.34188L8.4825 7.79067H10.17C10.5975 7.8188 10.44 8.34755 10.0969 8.34755V8.32505Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32574"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBab);
export default __webpack_public_path__ + "static/media/bab.b4a7b80a6ac49bcd6978deafea70e250.svg";
export { ForwardRef as ReactComponent };